exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tutor[data-v-ac7e16ea] {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n.actions[data-v-ac7e16ea] {\n  display: flex;\n  justify-content: center;\n}\n.card-flex[data-v-ac7e16ea] {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n.card-flex > div[data-v-ac7e16ea] {\n  flex: 0 1 auto;\n}\n.card-title[data-v-ac7e16ea] {\n  flex: 1 1 auto !important;\n  align-items: start;\n}\n.subheader[data-v-ac7e16ea] {\n  display: flex;\n  justify-content: space-between;\n}\n.w100[data-v-ac7e16ea] {\n  width: 100%;\n}\n", ""]);

// exports
